import React, { useState } from 'react';
import { IconButton, ButtonGroup, Button } from 'components/ui';
import Popover from 'components/shared/popover';
import { routes } from 'constants/config';
import cn from 'classnames';
import request from 'utils/request_ajax';
import HideLessonNavIcon from './icons/HideLessonNavIcon';
import ShowLessonNavIcon from './icons/ShowLessonNavIcon';

const ToggleLessonNav = ({ isOpen, setIsOpen, showPopover, className }) => {
  const [popoverOpen, setPopoverOpen] = useState(showPopover);
  const tooltipText = isOpen
    ? t('learning.lessons.scorm_toggle_nav.hide_tooltip')
    : t('learning.lessons.scorm_toggle_nav.show_tooltip');

  const updateUserSettings = async () => {
    const settingsData = {
      user_settings: { dismiss_lesson_details_hidden_popover: 'true' },
    };
    const data = await request.postJSON(
      routes.SETTINGS.UPDATE_USER_SETTINGS,
      settingsData,
    );
    if (data.success) {
      setPopoverOpen(false);
    }
  };

  const onToggleClick = e => {
    e.preventDefault();
    updateUserSettings();
    setIsOpen(!isOpen);
  };

  return (
    <div className={cn('ToggleLessonNav', { [className]: !!className })}>
      <IconButton
        className="ToggleLessonNav--Trigger"
        tooltip={!popoverOpen && tooltipText}
        tooltipProps={{ align: 'end' }}
        onClick={onToggleClick}
      >
        {isOpen ? <HideLessonNavIcon /> : <ShowLessonNavIcon />}
      </IconButton>
      {popoverOpen && (
        <Popover styleName="ToggleLessonNav--Popover" position="right">
          <div className="lh-24 fz-16 fw-b c-black">
            {t('learning.lessons.scorm_toggle_nav.popover_header')}
            <span className="ml-4" role="img" aria-label="Sparkles">
              ✨
            </span>
          </div>

          <div className="mt-8 c-midnight-100 lh-24 fz-16">
            {t('learning.lessons.scorm_toggle_nav.popover_text')}
          </div>
          <ButtonGroup alignEnd className="ai-c mt-16">
            <Button onClick={updateUserSettings} customColor>
              {t('learning.lessons.scorm_toggle_nav.got_it')}
            </Button>
          </ButtonGroup>
        </Popover>
      )}
    </div>
  );
};

export default ToggleLessonNav;
